import { render, staticRenderFns } from "./GoodsDeliver.vue?vue&type=template&id=fc605cb4&"
import script from "./GoodsDeliver.vue?vue&type=script&lang=js&"
export * from "./GoodsDeliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports